import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";
import { Box, Typography } from "@mui/material";
import Colors from "../../../assets/styles";

const AgentActivityChart = ({ data }) => {

    const dynamicWidth = Math.max(data.length * 60, 500);

    const getFirstName = (fullName) => {
        if (!fullName) return "";
        return fullName.trim().split(" ")[0];
    };

    const chartData = data.map((agent) => ({
        name: agent.name,
        Logins: agent.loginCount || 0,
        Visits: agent.visitCount || 0,
        Viewings: agent.viewingCount || 0,
        Sold: agent.soldCount || 0,
        Feedbacks: agent.FeedbackCount || 0,
    }));

    const AgentHorizontalChart = () => {
        const chartData1 = data.map((a) => ({
            name: getFirstName(a.name),
            Total: a.totalActivity,
        }));

        return (
            <Box sx={{ mt: 3, p: 3, bgcolor: "#fff", borderRadius: 2 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 600, mb: 2 }}>
                    Agent Activity Ranking
                </Typography>

                <Box sx={{ width: "100%", overflowX: "auto" }}>
                {/* The inner container must be wider than the parent to trigger scrolling */}
                <Box sx={{ width: dynamicWidth, height: 400 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} margin={{ bottom: 20 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis 
                                dataKey="name" 
                                interval={0}       // Forces every name to show
                                angle={-45}        // Slants names so they don't overlap
                                textAnchor="end"   // Aligns slanted text correctly
                                height={60}        // Extra space for labels
                            />
                            <YAxis />
                            <Tooltip />
                            <Legend verticalAlign="top" height={36}/>
                            <Bar dataKey="Logins" fill="#1976d2" />
                            <Bar dataKey="Visits" fill="#0288d1" />
                            <Bar dataKey="Viewings" fill="#2e7d32" />
                            <Bar dataKey="Sold" fill="#ed6c02" />
                            <Bar dataKey="Feedbacks" fill="#6a1b9a" />
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </Box>
            </Box>
        );
    };

    return (
        <>
            <Box
                sx={{
                    mt: 4,
                    p: 3,
                    bgcolor: "#fff",
                    borderRadius: 2,
                    boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
                    // width:"480px"
                    width: "auto"
                }}
            >
                <Typography
                    sx={{ fontSize: "20px", fontWeight: 600, mb: 2, color: Colors.primary }}
                >
                    Agent Activity Overview
                </Typography>

                    <Box sx={{ width: "100%", overflowX: "auto" }}>
                {/* The inner container must be wider than the parent to trigger scrolling */}
                <Box sx={{ width: dynamicWidth, height: 400 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} margin={{ bottom: 20 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis 
                                dataKey="name" 
                                interval={0}       // Forces every name to show
                                angle={-45}        // Slants names so they don't overlap
                                textAnchor="end"   // Aligns slanted text correctly
                                height={60}        // Extra space for labels
                                tick={{ fontSize: 12, fontWeight: 500, fill: '#666' }}
                            />
                            <YAxis />
                            <Tooltip />
                            <Legend verticalAlign="top" height={36}/>
                            <Bar dataKey="Logins" fill="#1976d2" />
                            <Bar dataKey="Visits" fill="#0288d1" />
                            <Bar dataKey="Viewings" fill="#2e7d32" />
                            <Bar dataKey="Sold" fill="#ed6c02" />
                            <Bar dataKey="Feedbacks" fill="#6a1b9a" />
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </Box>
            </Box>

            {AgentHorizontalChart}
        </>
    );
};

export default AgentActivityChart;